import React from 'react'

export default function SmartviewTextGroup ({ children }) {
  return (
    <div className='group space-y-5'>
      {children}
    </div>
  )
}
